import {ProcedureEditorContext} from './ProcedureEditorContext';
import {ProcedureValidationContext} from './validation/ProcedureValidationContext';
import {
  ProcedureValidationErrorType,
  ProcedureValidationObjectType,
} from './validation/ProcedureValidationTypes';
import {findRelevantProcedureValidationErrors} from './validation/procedureValidationUtils';

const ALLOWABLE_ERRORS_DURING_NAME_EDITS = [
  ProcedureValidationErrorType.INVALID_NAME,
  ProcedureValidationErrorType.NON_UNIQUE_NAME,
];

export function useMethodNodeValidation(methodCid: string): boolean {
  const {editingNameMethodCid} = ProcedureEditorContext.useContext();
  const {procedureValidationErrors} = ProcedureValidationContext.useContext();

  const methodValidationErrors = findRelevantProcedureValidationErrors(procedureValidationErrors, {
    id: methodCid,
    objectType: ProcedureValidationObjectType.METHOD,
  });

  return (
    methodValidationErrors.filter((error) => {
      if (editingNameMethodCid === methodCid) {
        return !(
          error.primaryObject.id === methodCid && ALLOWABLE_ERRORS_DURING_NAME_EDITS.includes(error.type)
        );
      } else {
        return true;
      }
    }).length !== 0
  );
}
